module.exports = __webpack_public_path__ + "img/box2.3841142d.png";